module.exports = __webpack_public_path__ + "static/img/bg3.7da42803.png";